import React from 'react';
import {sx} from "@containers/singleVoyage/mutateVoyage/points/pointSidebar/sx";
import HeaderSidebarMutateSingleVoyage from "./header/HeaderSidebarMutateSingleVoyage";
import {Stack} from '@mui/material';
import SaveVoyageBtn from "@containers/singleVoyage/mutateVoyage/saveVoyage/SaveVoyageBtn";
import MutateRouteMutateWithHotUpdateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/MutateRouteMutateWithHotUpdateSingleVoyage";


const RouteSidebarMutateSingleVoyage = () => {

    return (
        <Stack
            sx={sx.root}
        >
            <HeaderSidebarMutateSingleVoyage/>

            <MutateRouteMutateWithHotUpdateSingleVoyage/>

            <SaveVoyageBtn/>
        </Stack>
    )
};

export default RouteSidebarMutateSingleVoyage;